import React from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  Container
} from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';

export const Navigation: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleNavigation = (path: string) => {
    navigate(path);
  };

  return (
    <AppBar position="static" sx={{ mb: 4 }}>
      <Container maxWidth="lg">
        <Toolbar sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Typography
            variant="h6"
            component="div"
            sx={{ cursor: 'pointer' }}
            onClick={() => handleNavigation('/')}
          >
            VIPAR Parts
          </Typography>

          <Box sx={{ display: 'flex', gap: 2 }}>
            <Button
              color="inherit"
              onClick={() => handleNavigation('/')}
              sx={{
                fontWeight: location.pathname === '/' ? 'bold' : 'normal',
                textDecoration: location.pathname === '/' ? 'underline' : 'none'
              }}
            >
              Catalog
            </Button>
            <Button
              color="inherit"
              onClick={() => handleNavigation('/service')}
              sx={{
                fontWeight: location.pathname === '/service' ? 'bold' : 'normal',
                textDecoration: location.pathname === '/service' ? 'underline' : 'none'
              }}
            >
              Recognition
            </Button>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};
